/**
 * BarChart path props for a prevalence section's rows.
 *
 * Without a breakdown each row is a single `count`. With one, the BE returns
 * the breakdown values as `children`, and BarChart wants one path per series,
 * so the paths become arrays sized to the widest row.
 */
const annoHasNoChildren = (arr) => arr.every((d) => !d.children || d.children.length === 0);

const annoMaxChildrenLength = (arr) =>
  arr.reduce((max, d) => Math.max(max, d.children?.length || 0), 0);

const makeArrayFromLength = (n) => Array.from({ length: n });

export const buildAnnoValuePath = (arr) => {
  if (!arr?.length || annoHasNoChildren(arr)) return "count";
  return makeArrayFromLength(annoMaxChildrenLength(arr)).map((_, i) => `children.${i}.count`);
};

export const buildAnnoTooltipLabelsPath = (arr) => {
  if (!arr?.length || annoHasNoChildren(arr)) return "display";
  return makeArrayFromLength(annoMaxChildrenLength(arr)).map((_, i) => `children.${i}.display`);
};
